import React, { useState } from "react";
import { useEffect } from "react";
import Share from "./Share";
import { appShareTextString, checkMobile, WEB_BASE_URL } from "../utils/helper";
import S3 from "aws-sdk/clients/s3";
import AWS from "aws-sdk/global";
import moment from "moment";
import Loader from "../Popup/Loader";
import html2canvas from "html2canvas";
import ErrorPopup from "../Popup/ErrorPopup";

export default function NativeShare({
  item,
  children,
  id,
  showSharePopup,
  openPopup,
  closePopup,
  shareUrl,
}) {
  const [showSharePopupp, setShowSharePopup] = useState(false);
  const [canvasKey, setCanvasKey] = useState("");
  const [originalKey, setOriginalKey] = useState("");
  const [bucketUrl, setBucketUrl] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [message, setMessage] = useState("");

  const bucketname = "js-sdk-bucket";
  AWS.config.region = "ap-south-1"; // Region
  AWS.config.credentials = new AWS.CognitoIdentityCredentials({
    IdentityPoolId: "ap-south-1:84027705-475d-4ca1-bac8-b2eb7407ae9f",
  });
  const bucket = new AWS.S3({
    params: {
      Bucket: bucketname,
    },
  });

  useEffect(() => {
    initialize();
  }, []);

  const initialize = () => {
    let date = moment().format("DD-MM-yyyy");
    var sessionid = Date.now();
    localStorage.setItem("sessionid", sessionid);

    var bucketUrlkey =
      "https://s3.ap-south-1.amazonaws.com/" + date + "/" + bucketname + "/";
    var canvaskey =
      "bjpmembership2024/" +
      date +
      "/canvas_" +
      Math.floor(100000 + Math.random() * 900000) +
      "_" +
      localStorage.getItem("sessionid") +
      ".jpg";
    console.log("canvaskey", canvaskey);
    var originalkey =
      "bjpmembership2024/original_" +
      localStorage.getItem("sessionid") +
      ".jpg";

    setCanvasKey(canvaskey);
    setOriginalKey(originalkey);
    setBucketUrl(bucketUrlkey);
  };
  let link = localStorage.getItem("sharelink");

  link = link
    ? link.replace(
        "https://nm-4.com/bjpmem/",
        "https://www.narendramodi.in/bjpsadasyata2024/"
      )
    : "";
  const quote = `Greetings, I have become a primary member of the BJP. You too can join the Party using my referral link : ${link} #BJPSadasyata2024`;

  const generateSharecanvas = () => {
    let shareUrl1 = localStorage.getItem("canvasimage");
    if (shareUrl1) {
      handleShare(shareUrl1);
    } else {
      setLoading(true);
      window.scrollTo(0, 0);

      const images = document.querySelectorAll("#generate_canvas_div img");
      let loadedImagesCount = 0;

      images.forEach((image) => {
        if (image.complete) {
          loadedImagesCount++;
        } else {
          image.onload = () => {
            loadedImagesCount++;
            if (loadedImagesCount === images.length) {
              captureCanvas();
            }
          };
        }
      });

      if (loadedImagesCount === images.length) {
        captureCanvas();
      }

      async function captureCanvas() {
        html2canvas(document.querySelector("#generate_canvas_div"), {
          width: 1200,
          height: 750,
          scale: 1,
          useCORS: true,
        }).then(async (canvas) => {
          canvas.toBlob(async (blob) => {
            if (blob) {
              var file = new File([blob], "filename");
              let alias_url = "https://campaign-images.narendramodi.in/";
              uploadToS3(file, "canvas", bucket, () =>
                handleShare(alias_url + canvasKey)
              );
              setLoading(false);
            }
          }, "image/jpeg");
        });
      }
    }
  };

  const uploadToS3 = (file, type, bucket, callback) => {
    var objKey = null;
    if (type === "canvas") {
      objKey = canvasKey;
    } else if (type === "original") {
      objKey = originalKey;
    }

    var params = {
      Key: objKey,
      ContentType: file.type ? file.type : "image/jpeg",
      Body: file,
      ACL: "public-read",
    };
    if (!callback) {
      callback = (err, data) => {};
    }
    bucket.putObject(params, callback);
  };

  const handleNativeShare = async (shareimg) => {
    let shareUrl1 = localStorage.getItem("canvasimage")
      ? localStorage.getItem("canvasimage")
      : shareimg;
    let title = quote;
    let text = quote;
    let url = shareUrl1;
    let data = {
      text,
    };
    if (navigator && navigator.share) {
      if (shareUrl1) {
        setLoading(true);
        const mediafile = shareUrl1;
        const fileSpliteString = mediafile.split(".");
        let extension = fileSpliteString[fileSpliteString.length - 1];
        const filename = `${title}_img.${extension}`;

        const response = await fetch(mediafile);
        const blob = await response.blob();
        const blobUrl = URL.createObjectURL(blob);
        console.log("blob", blobUrl);
        const file = new File([blob], filename, {
          type: blob.type,
        });
        console.log("file", file);
        data["files"] = [file];
        navigator
          .share(data)
          .then(() => {
            console.log("Successfully native shared data");
          })
          .catch((error) => {
            console.log("Error native sharing", error);
          });
        setLoading(false);
      } else {
        setError(true);
        setMessage("Image not ready for sharing.");
      }
    } else {
      setError(true);
      setMessage("Native Share not supported");
    }
  };

  const handleShare = async (imageUrl) => {
    let shareUrl1 = localStorage.getItem("canvasimage")
      ? localStorage.getItem("canvasimage")
      : imageUrl;
    try {
      localStorage.setItem("canvasimage", imageUrl);
      //indexOf appversion

      if (window.location.href.indexOf("appversionios") != -1) {
        var sharelink = `appshare://?imageurl=${encodeURIComponent(imageUrl)}&text=${quote}`;
        window.location.href = sharelink;
        try {
          let obj = {};

          window.gtag("event", ` Shared`, obj);
        } catch (error) {}
      } else if (window.location.href.indexOf("appversionandroid") != -1) {
        var sharelink = `appshare://text=${encodeURIComponent(quote)}&imageurl=${imageUrl}`;
        window.location.href = sharelink;
        try {
          let obj = {};
          window.gtag("event", ` Shared`, obj);
        } catch (error) {}
      } else if (checkMobile() != "mobile") {
        let obj = {
          shareUrl1,
        };
        openPopup(obj);
      } else {
        handleNativeShare(shareUrl1);
      }
    } catch (e) {
      console.log("error", e);
      handleNativeShare(shareUrl1);
    }
  };

  const closeSharePopup = () => {
    setShowSharePopup(false);
  };
  const popupclose = () => {
    setError(false);
  };
  return (
    <>
      {loading && <Loader />}
      {error && <ErrorPopup message={message} popupclose={popupclose} />}
      {}
      <div
        onClick={() => {
          // handleShare();
          generateSharecanvas();
        }}
      >
        {children}
      </div>
      {showSharePopupp && (
        <Share
          closeShare={closeSharePopup}
          shareUrl={localStorage.getItem("canvasimage")}
        />
      )}
    </>
  );
}
